/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** Step = step challenge, Spend = spend challenge */
export type ChallengeProgressType = 'Spend' | 'Step';

/** NOT_STARTED = Customer is qualified for challenge, STARTED = Customer has opted in, IN_PROGRESS: challenge is in progress, COMPLETED: customer has completed the challenge */
export type ChallengeStatus = 'COMPLETED' | 'IN_PROGRESS' | 'NOT_STARTED' | 'STARTED';

export type ChallengeTheme = 'DEFAULT' | 'FLASH';

export type LoyaltyOfferOptInOnFocusMutationVariables = Exact<{
  challengeId: string;
}>;

export type LoyaltyOfferOptInOnFocusMutation = {
  readonly challengeOptInV2:
    | {
        readonly __typename: 'Challenge';
        readonly assetUrl: string | null;
        readonly achieved: number;
        readonly celebrationCopy: string;
        readonly descriptiveTitle: string;
        readonly expirationDate: string | null;
        readonly goal: number;
        readonly id: string;
        readonly theme: Types.ChallengeTheme;
        readonly legalTerms: string;
        readonly percentageCompleted: number;
        readonly permalink: string;
        readonly progressType: Types.ChallengeProgressType;
        readonly progress: number;
        readonly progressCopy: string;
        readonly status: Types.ChallengeStatus;
        readonly title: string;
      }
    | { readonly __typename: 'LoyaltyOptInFailed'; readonly errorMessage: string };
};

export const LoyaltyOfferOptInOnFocusDocument = gql`
  mutation loyaltyOfferOptInOnFocus($challengeId: String!) {
    challengeOptInV2(challengeId: $challengeId) {
      __typename
      ... on Challenge {
        __typename
        assetUrl
        achieved
        celebrationCopy
        descriptiveTitle
        expirationDate
        goal
        id
        theme
        legalTerms
        percentageCompleted
        permalink
        progressType
        progress
        progressCopy
        status
        title
      }
      ... on LoyaltyOptInFailed {
        __typename
        errorMessage
      }
    }
  }
`;

export function useLoyaltyOfferOptInOnFocusMutation() {
  return Urql.useMutation<
    LoyaltyOfferOptInOnFocusMutation,
    LoyaltyOfferOptInOnFocusMutationVariables
  >(LoyaltyOfferOptInOnFocusDocument);
}
